// extracted by mini-css-extract-plugin
export default {"content":"_RESBp4A","text":"afXmlD21","headline":"d_qW7ntS","icon":"DcRdv0wy","image":"LBsCnzTr","mobile":"mobile","time":"HfseDvUu"};